module.exports = __webpack_public_path__ + "static/img/p4.31da9711.png";